/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ year: NonNullable<unknown> }} Progress_Extra_Wrapped_YearInputs */

const en_us2_progress_extra_wrapped_year = /** @type {(inputs: Progress_Extra_Wrapped_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.year} in review`)
};

const pt_br2_progress_extra_wrapped_year = /** @type {(inputs: Progress_Extra_Wrapped_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retrospectiva de ${i?.year}`)
};

const es_419_progress_extra_wrapped_year = /** @type {(inputs: Progress_Extra_Wrapped_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resumen de ${i?.year}`)
};

const pt_pt2_progress_extra_wrapped_year = /** @type {(inputs: Progress_Extra_Wrapped_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Retrospetiva de ${i?.year}`)
};

const fr_fr2_progress_extra_wrapped_year = /** @type {(inputs: Progress_Extra_Wrapped_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.year} en bref`)
};

const de_de2_progress_extra_wrapped_year = /** @type {(inputs: Progress_Extra_Wrapped_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rückblick ${i?.year}`)
};

const it_it2_progress_extra_wrapped_year = /** @type {(inputs: Progress_Extra_Wrapped_YearInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riepilogo del ${i?.year}`)
};

/**
* | output |
* | --- |
* | "{year} in review" |
*
* @param {Progress_Extra_Wrapped_YearInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_wrapped_year = /** @type {((inputs: Progress_Extra_Wrapped_YearInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Wrapped_YearInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_wrapped_year(inputs)
	if (locale === "es-419") return es_419_progress_extra_wrapped_year(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_wrapped_year(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_wrapped_year(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_wrapped_year(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_wrapped_year(inputs)
	return en_us2_progress_extra_wrapped_year(inputs)
});
export { progress_extra_wrapped_year as "progress-extra.wrapped_year" }